<template>
  <div class="file-element-wrapper">
    <div class="header">
      <a-icon :type="fileType" class="file-icon" />
      <div class="file-element">
        <span class="file-name">{{ fileName }}</span>
        <div>
          <span class="file-size">{{ size }}</span><span
            class="downLoad"
            v-if="message.status !== 'fail' && !showProgressBar"
            @click="downloadFile"
            title="下载文件"
            ><span class="divider">丨</span>下载</span
          ><span class="fail" v-if="message.status === 'fail'">丨上传失败</span>
        </div>
      </div>
    </div>
    <a-progress v-if="showProgressBar" :percent="upFilePercent" />
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "FileElem",
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  inject: ["message"],
  computed: {
    ...mapState("im", ["upFilePercent"]),
    fileName() {
      return this.payload.fileName;
    },
    fileUrl() {
      return this.payload.url;
    },
    fileType() {
      if (this.payload.fileName.indexOf(".png") > 0) {
        return "file-image";
      } else if (this.payload.fileName.indexOf(".pdf") > 0) {
        return "file-pdf";
      } else if (this.payload.fileName.indexOf(".word") > 0) {
        return "file-word";
      } else if (this.payload.fileName.indexOf(".ppt") > 0) {
        return "file-ppt";
      } else if (this.payload.fileName.indexOf(".text") > 0) {
        return "file-text";
      } else if (this.payload.fileName.indexOf(".zip") > 0) {
        return "file-zip";
      } else if (this.payload.fileName.indexOf(".excel") > 0) {
        return "file-excel";
      }
      return "file";
    },
    size() {
      const size = this.payload.fileSize;
      if (size > 1024) {
        if (size / 1024 > 1024) {
          return `${this.toFixed(size / 1024 / 1024)} Mb`;
        }
        return `${this.toFixed(size / 1024)} Kb`;
      }
      return `${this.toFixed(size)}B`;
    },
    showProgressBar() {
      return this.message.status === "unSend";
    },
    percent() {
      return Math.floor((this.message.progress || 0) * 100);
    }
  },
  mounted() {
    // console.log(this.payload);
  },
  methods: {
    toFixed(number, precision = 2) {
      return number.toFixed(precision);
    },
    downloadFile() {
      // 浏览器支持fetch则用blob下载，避免浏览器点击a标签，跳转到新页面预览的行为
      // if (window.fetch) {
      //   fetch(this.fileUrl)
      //     .then(res => res.blob())
      //     .then(blob => {
      //       let a = document.createElement("a");
      //       let url = window.URL.createObjectURL(blob);
      //       a.href = url;
      //       a.download = this.fileName;
      //       a.click();
      //     });
      // } else {
        console.log(this.fileUrl);
        let a = document.createElement("a");
        a.href = this.fileUrl;
        // a.target = "_blank";
        a.download = this.filename;
        a.click();
      // }
    }
  }
};
</script>
<style lang="scss" scoped>
.file-element-wrapper {
  // cursor: pointer;
}
.header {
  display: flex;
}
.file-icon {
  font-size: 40px !important;
}
.file-element {
  display: flex;
  flex-direction: column;
  margin-left: 12px;
}
.file-size {
  font-size: 12px;
  padding-top: 5px;
}
.downLoad {
  font-size: 12px;
  padding-right: 10px;
  cursor: pointer;
}
.fail {
  font-size: 12px;
  padding-right: 10px;
}
</style>
